<template>
  <div class="Content">

    <app-leftcolumn>
      <left-menu></left-menu>
    </app-leftcolumn>

    <div class="bloc-center-row">
      <app-centercolumn>
        <router-view></router-view>
      </app-centercolumn>

      <app-widgetcentercolumn>
        <preview></preview>
      </app-widgetcentercolumn>
    </div>


    <app-rightcolumn>
      <widget-calendar></widget-calendar>
      <meeting-view></meeting-view>
      <preview></preview>
    </app-rightcolumn>

  </div>
</template>

<script>
  // placeholders components
  import AppLeftcolumn from '../columns/Leftcolumn.vue'
  import AppCentercolumn from '../columns/Centercolumn.vue'
  import AppWidgetcentercolumn from '../columns/WidgetCentercolumn.vue'
  import AppRightcolumn from '../columns/Rightcolumn.vue'

  import LeftMenu from '../menu/LeftMenu.vue'
  import ProjectsList from '../projects/ProjectsList.vue'
  // import Something from '../widgets/Something.vue'

  import WidgetCalendar from 'src/components/widgets/Calendar.vue'
  import Preview from '../grid/Preview.vue'

  import MeetingView from 'src/components/widgets/MeetingView.vue'

  export default{
    components: {
      AppLeftcolumn, AppCentercolumn, AppWidgetcentercolumn, AppRightcolumn,
      LeftMenu, ProjectsList, WidgetCalendar, Preview, MeetingView
    }
  }
</script>



// WEBPACK FOOTER //
// ProjectView.vue?5eedab0c